export const kToolbarHeight = 64;

export const kImageLogoPlaceholder =
  "https://www.defectwise.com.au/wp-content/uploads/2024/11/transparent-logo-image-placeholder.png";

export const kImageProjectPlaceholder =
  "https://www.defectwise.com.au/wp-content/uploads/2024/11/transparent-project-image-placeholder.png";
